/**
 * Download URLs for Rumio applications
 * These can be overridden by environment variables
 */

// Chrome Extension URL
export const CHROME_EXTENSION_URL =
  import.meta.env.VITE_CHROME_EXTENSION_URL ||
  'https://chrome.google.com/webstore/detail/rumio/coming-soon';

// iOS App Store URL
export const IOS_APP_URL =
  import.meta.env.VITE_IOS_APP_URL ||
  'https://apps.apple.com/app/rumio/idcoming-soon';

// Android Google Play URL
export const ANDROID_APP_URL =
  import.meta.env.VITE_ANDROID_APP_URL ||
  'https://play.google.com/store/apps/details?id=com.rumio.app';

/**
 * Helper to check if a download URL is a placeholder
 * Placeholder URLs contain 'coming-soon' or 'placeholder'
 */
export function isPlaceholderUrl(url: string): boolean {
  return url.includes('coming-soon') || url.includes('placeholder');
}

/**
 * Get all download URLs as a record
 */
export const DOWNLOAD_URLS = {
  chromeExtension: CHROME_EXTENSION_URL,
  iosApp: IOS_APP_URL,
  androidApp: ANDROID_APP_URL,
} as const;